const Cat_TipoResolucion = {
  ObtenerTipoResolucion: 'SICPE/Catalogo/GetTipodeResolucion'
}

const catalogos = {
  ObtenerTipoResolucion: Cat_TipoResolucion,
  };
  
  export default catalogos;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPE/catalogos/catalogos.js
// module id = null
// module chunks = 